import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'zip_code_protection-zipcodeprotectionmodal-view';
/**
 * Open zip code protection modal
 */
export function trackZipCodeProtectionZipcodeprotectionmodalView(brandToken) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { brandToken },
    });
}
